import {FACTIONS} from "../../../constants/factions";

export const AQUARS_QUOTES = [{
  quote: 'Одно озеро — лагерь. Другое — фланг. Третье — ваша могила. И все три соединены одной нашей волей',
  author: 'Щиш Тхо, аквар-арканщик Тихого озера',
  factionId: FACTIONS.AQUARS
}, {
  quote: 'У воды мы — боги. Вдали от воды — просто ящеры. Но вы почему-то всегда воюете у рек. Спасибо за глупость',
  author: 'Иктис Тетроген, аквар-магистр водных врат',
  factionId: FACTIONS.AQUARS
}, {
  quote: 'Ты построил крепость у озера. Ты либо гений, либо самоубийца',
  author: 'Аракс Ктенус, аквар-префект Речного кордона',
  factionId: FACTIONS.AQUARS
}, {
  quote: 'Каждый водоём — это глаз. Глаз смотрит на тебя, когда ты пьешь',
  author: 'Тифон Лерней, аквар-прокурор Затопленных копий',
  factionId: FACTIONS.AQUARS
}]